import * as HTML_RENDITION from '../../utils/general/general';
import UserAgentUtils from '../../utils/general/userAgentUtils';
import _ from 'lodash';

export const showPrint = (propsIssuerPageData: any) => {
    if (HTML_RENDITION.isPreview() || HTML_RENDITION.isCVMobileApp()){
        return false;
    }
    if (!propsIssuerPageData) {
      return false;
    }
    if (!propsIssuerPageData.financialsBlock) {
      return false;
    }
    if (!propsIssuerPageData.financialsBlock.showPrint) {
      return false;
    }
    if (UserAgentUtils.isMobile.any()) {
      return false;
    }
    return propsIssuerPageData.financialsBlock.showPrint;
};

export const showTags = (propsIssuerPageData: any) => {
    return propsIssuerPageData
      && propsIssuerPageData.financialsBlock
      && propsIssuerPageData.financialsBlock.showTags === 'true';
};
//  point/roundup/golobaliser
export const showTOC = (propsData: any) => {
    if (HTML_RENDITION.isCompendiumProduct()) {
        return false;
    }
    if (HTML_RENDITION.isPresentation()) {
        return false;
    }
    if (_.isUndefined(propsData)) {
        return false;
    }
    return true;
};

export const cvMenu = (propsIssuerPageData: any) => {
    if (
      HTML_RENDITION.isAuthPreview() ||
      HTML_RENDITION.isCVMobileApp() ||
      HTML_RENDITION.isHTMLLightRendition()
    ) {
        return false;
    }
    if (!HTML_RENDITION.isAppInsideCViFrame()) {
      return false;
    }
    if (!propsIssuerPageData) {
      return false;
    }
    if (!propsIssuerPageData.financialsBlock) {
      return false;
    }
    if (!propsIssuerPageData.financialsBlock.cvMenu) {
      return true;
    }
    return propsIssuerPageData.financialsBlock.cvMenu;
};

export const showFloatMenuCopy = (propsInitialData: any) => {
    if (propsInitialData) {
        return false;
    }
    if (UserAgentUtils.isInsideCVApp.any()) {
        return false;
    }
    if (HTML_RENDITION.isPreview()) {
        return false;
    }
    if (HTML_RENDITION.isGCB_CBOL()) {
        return false;
    }
    return true;
};
